// src/pages/league-dashboard/standings/HeadToHeadStandings.js
//
// Extracted from inline closure in LeagueStandings.js per IMPORTANT
// batch 6 commit 6a. Closure-→-prop conversion: parent's
// `teamsWithLogos`, `league`, `leagueId` promoted to declared props.
import React from 'react';
import { dynastyTheme } from '../../../services/colorService';
import TeamLinkDropdown from '../../../components/league-dashboard/TeamLinkDropdown';
import TeamLogo from './TeamLogo';

const HeadToHeadStandings = ({ teamsWithLogos, league, leagueId }) => {
  const getAllTeamSlots = () => {
    const maxTeams = league?.league_settings?.max_teams || 12;
    const allSlots = [];

    for (let slotNumber = 1; slotNumber <= maxTeams; slotNumber++) {
      const activeTeam = teamsWithLogos.find((team, index) => index + 1 === slotNumber);

      if (activeTeam) {
        allSlots.push({
          ...activeTeam,
          slot: slotNumber,
          status: 'active',
          isEmpty: false
        });
      } else {
        allSlots.push({
          slot: slotNumber,
          team_name: `Team ${slotNumber}`,
          manager_name: null,
          wins: null,
          losses: null,
          ties: null,
          points: null,
          status: 'empty',
          isEmpty: true
        });
      }
    }
    return allSlots;
  };

  const allTeamSlots = getAllTeamSlots();

  return (
    <div className={dynastyTheme.components.card.base}>
      <div className={`px-4 py-2 border-b ${dynastyTheme.classes.border.neutral}`}>
        <h3 className={`text-base font-bold ${dynastyTheme.classes.text.white}`}>
          Head-to-Head Standings
        </h3>
      </div>
      <div className="p-6">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className={`border-b ${dynastyTheme.classes.border.neutral}`}>
                <th className={`text-left p-3 ${dynastyTheme.classes.text.white} font-semibold`}>Rank</th>
                <th className={`text-left p-3 ${dynastyTheme.classes.text.white} font-semibold`}>Team</th>
                <th className={`text-center p-3 ${dynastyTheme.classes.text.white} font-semibold`}>W</th>
                <th className={`text-center p-3 ${dynastyTheme.classes.text.white} font-semibold`}>L</th>
                <th className={`text-center p-3 ${dynastyTheme.classes.text.white} font-semibold`}>T</th>
                <th className={`text-center p-3 ${dynastyTheme.classes.text.white} font-semibold`}>Pts</th>
                <th className={`text-center p-3 ${dynastyTheme.classes.text.white} font-semibold`}>Status</th>
              </tr>
            </thead>
            <tbody>
              {allTeamSlots.map((team, index) => (
                <tr key={index} className={`border-b hover:bg-black/20 ${dynastyTheme.classes.transition} ${dynastyTheme.classes.border.neutral}`}>
                  <td className={`p-3 ${dynastyTheme.classes.text.white} font-semibold`}>{team.slot}</td>
                  <td className="p-3">
                    <div className="flex items-center gap-2">
                      {!team.isEmpty && <TeamLogo team={team} size="small" />}
                      <div>
                        {/* UPDATED: Use TeamLinkDropdown for active teams */}
                        {team.status === 'active' ? (
                          <TeamLinkDropdown
                            team={team}
                            leagueId={leagueId}
                            className={dynastyTheme.classes.text.white}
                          />
                        ) : (
                          <div className={`${dynastyTheme.classes.text.neutralLighter} italic`}>
                            {team.team_name}
                          </div>
                        )}
                        {team.manager_name && (
                          <div className={`text-xs ${dynastyTheme.classes.text.neutralLight}`}>
                            {team.manager_name}
                          </div>
                        )}
                      </div>
                    </div>
                  </td>
                  <td className={`p-3 text-center ${dynastyTheme.classes.text.white}`}>
                    {team.wins !== null ? team.wins : '-'}
                  </td>
                  <td className={`p-3 text-center ${dynastyTheme.classes.text.white}`}>
                    {team.losses !== null ? team.losses : '-'}
                  </td>
                  <td className={`p-3 text-center ${dynastyTheme.classes.text.white}`}>
                    {team.ties !== null ? team.ties : '-'}
                  </td>
                  <td className={`p-3 text-center ${dynastyTheme.classes.text.white} font-bold`}>
                    {team.points !== null ? team.points : '-'}
                  </td>
                  <td className="p-3 text-center">
                    <span className={
                      team.status === 'active'
                        ? dynastyTheme.components.badge.success
                        : dynastyTheme.components.badge.info
                    }>
                      {team.status === 'active' ? 'Active' : 'Empty'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default HeadToHeadStandings;
